import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import CustomRecurrenceModal from "./CustomRecurrenceModal";
import "./RecurrenceSelector.css";

const RecurrenceSelector = ({ value, onChange, disabled = false }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);

  // Generate display text for current recurrence
  const getDisplayText = () => {
    if (!value || value.frequency === "none") {
      return "Does not repeat";
    }

    const { frequency, interval, endType, occurrences, endDate } = value;
    let text = "";

    // Build frequency text
    if (frequency === "daily" || frequency === "day") {
      text = interval === 1 ? "Daily" : `Every ${interval} days`;
    } else if (frequency === "weekly" || frequency === "week") {
      text = interval === 1 ? "Weekly" : `Every ${interval} weeks`;
    } else if (frequency === "monthly" || frequency === "month") {
      text = interval === 1 ? "Monthly" : `Every ${interval} months`;
    } else if (frequency === "yearly" || frequency === "year") {
      text = interval === 1 ? "Annually" : `Every ${interval} years`;
    } else {
      return "Recurring...";
    }

    // Add end condition
    if (endType === "on" && endDate) {
      const date = new Date(endDate);
      text += `, until ${date.toLocaleDateString("en-US", { month: "short", day: "numeric" })}`;
    } else if (endType === "after" && occurrences) {
      text += `, ${occurrences} times`;
    }

    return text;
  };

  const handleOptionSelect = (option) => {
    setIsDropdownOpen(false);

    if (option === "none") {
      onChange({ frequency: "none" });
    } else if (option === "recurring") {
      setIsCustomModalOpen(true);
    }
  };

  const handleCustomSave = (rule) => {
    onChange(rule);
  };

  // Check if recurrence is configured (not "does not repeat")
  const isRecurring = value && value.frequency && value.frequency !== "none";

  return (
    <div className="recurrence-selector">
      <div
        className={`recurrence-dropdown-trigger ${disabled ? "disabled" : ""}`}
        onClick={() => !disabled && setIsDropdownOpen(!isDropdownOpen)}
      >
        <span className="recurrence-text">{getDisplayText()}</span>
        <IoChevronDown size={18} className={`chevron ${isDropdownOpen ? "open" : ""}`} />
      </div>

      {isDropdownOpen && (
        <>
          <div className="recurrence-dropdown-overlay" onClick={() => setIsDropdownOpen(false)} />
          <div className="recurrence-dropdown-menu">
            <div
              className={`dropdown-option ${!isRecurring ? "selected" : ""}`}
              onClick={() => handleOptionSelect("none")}
            >
              Does not repeat
            </div>
            <div
              className={`dropdown-option ${isRecurring ? "selected" : ""}`}
              onClick={() => handleOptionSelect("recurring")}
            >
              Recurring...
            </div>
          </div>
        </>
      )}

      <CustomRecurrenceModal
        isOpen={isCustomModalOpen}
        onClose={() => setIsCustomModalOpen(false)}
        onSave={handleCustomSave}
        initialValue={value || { frequency: "week", interval: 1, endType: "after", occurrences: 13 }}
      />
    </div>
  );
};

export default RecurrenceSelector;
